import React from "react";
import { StyleSheet } from "react-native";
import { Spacing, EmptyState } from "@valkdigital/ui-kit";
import { useTranslation } from "react-i18next";

interface PaymentProcessingProps {}

const PaymentProcessing: React.FC<PaymentProcessingProps> = () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      heading={t("guest.payment.processing")}
      style={styles.container}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    padding: Spacing.sp2,
  },
});

export default PaymentProcessing;
